/**
 * Zod schemas for tRPC inputs.
 * Feature-specific validators are added by their respective prompts.
 */

import { z } from "zod";

export const idSchema = z.string().min(1);
export const paginationSchema = z.object({
  page: z.number().int().min(1).default(1),
  pageSize: z.number().int().min(1).max(100).default(20),
});

export type PaginationInput = z.infer<typeof paginationSchema>;

export * from "./brand-dna.js";
export * from "./campaign.js";
export * from "./carousel.js";
export * from "./competitor-template.js";
export * from "./content-writer.js";
